import React from 'react'
import styles from './Quote.module.css'; 
import {useNavigate} from 'react-router-dom';

// yaha se quote display hote hain
const Quotes = (props) => {

  const navigate = useNavigate();

  const showQuoteHandler = (id)=>{
    // console.log(id);
    navigate(`/quotes/${id}`);
  }



  return (
    <li className={styles.quote}>
        <p>{props.text}</p>
        <p>{props.author}</p>
        <button onClick={()=>showQuoteHandler(props.id)} >View Fullscreen</button>
    </li>
  )
}

export default Quotes;